<template>
  <v-btn color="primary" dark @click.prevent="btnClick" :loading="loading">
    {{labelName}}
    <v-icon dark right>mdi-printer</v-icon>
    <confirm v-model="promptConFlag" @ok="okBtn">
      Please ensure latest changes are saved before printing. Click OK to proceed.
    </confirm>
  </v-btn>
</template>
<script>
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import { extractMenu } from '@/utils/extract'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
export default {
  data() {
    return {
      promptConFlag: false,
      btnPrtSchForm: {
        // both uw and sched
        polNo: '',
        renCnt: 0,
        endtCnt: 0,
        noPrtSched: 1,
        callingProg: 'Draft',
        numberOfCopies: 1,
        format: 'PDF',
        reprint: false,
        uoiCustomised: false,
        callingProgram: 'Draft',
        polTypeAppId: undefined
      },
      reportMenu: {},
      polTypeAppId: undefined,
      printError: false,
      count: 0,
      loading: false
    }
  },
  computed: {
    rptMenu_uw() {
      return this.$store.state.reports.uwReports.menu
    },
    rptMenu_sched() {
      return this.$store.state.reports.scheduleReports.menu
    },
    commonMenu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    polTypeAppId: function(value) {
      if (value !== undefined && value !== '') {
        this.initReport()
      }
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    isValid() {
      return (
        this.polTypeAppId === 'CA' ||
        this.polTypeAppId === 'MI' ||
        this.polTypeAppId === 'FI' ||
        this.polTypeAppId === 'MO' ||
        this.polTypeAppId === 'HU'
      )
    },
    async getPolTypeAppId() {
      let paramString = this.polNo + ',' + this.renCnt + ',' + this.endtCnt
      await this.getCommonData('polTypeAppId', paramString)
    },
    async doInit() {
      if (this.$store.state.reports.init !== 1) {
        await this.$store.dispatch('reportsInit')
      }
      Promise.all([this.initReportMenu()])
      Promise.all([this.getPolTypeAppId()])
    },
    async initReportMenu() {
      if (this.$store.state.reports.uwReports.init !== 1) {
        Promise.all([this.$store.dispatch('uwReportsInit')])
      }
      if (this.$store.state.reports.scheduleReports.init !== 1) {
        Promise.all([this.$store.dispatch('scheduleReportsInit')])
      }
    },
    async initReport() {
      try {
        var apiURI = ''
        if (this.polTypeAppId === 'CA') {
          apiURI = this.rptMenu_sched.cargoSchedule
        } else {
          apiURI = this.rptMenu_uw.initUWMiscSched
        }
        // else if (this.polTypeAppId === 'HU' || this.polTypeAppId === 'MI') {
        //   apiURI = this.rptMenu_uw.initUWMiscSched
        // } else if (this.polTypeAppId === 'FI') {
        //   apiURI = this.rptMenu_sched.fireSchedule
        // } else if (this.polTypeAppId === 'MO') {
        //   apiURI = this.rptMenu_sched.motorSchedule
        // }
        if (apiURI !== '') {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            if (data) {
              this.reportMenu = extractMenu(result.data._links)
            }
          }
        }
      } catch (err) {
        this.printError = true
        throw err
      }
    },
    async btnClick() {
      if (this.confirmFlag === true) {
        this.promptConFlag = true
      } else {
        if (this.reportMenu.export === undefined) {
          await this.initReport()
        }
        await this.exportDraft()
      }
    },
    async okBtn() {
      this.promptConFlag = false
      this.exportDraft()
    },
    async exportDraft() {
      // if (this.printError) {
      //   this.$toast.error('Unable to print...')
      //   return
      // } else if (!this.isValid()) {
      //   this.$toast.error('PolType App Id:' + this.polTypeAppId + ' not yet ready.')
      //   return
      // }
      // let apiURI = this.getExportApiUri()
      let apiURI = this.reportMenu.export
      // console.log('apiURI - ex -' + apiURI)
      if (apiURI) {
        this.loading = true
        try {
          // let callingProg = ''
          // if (this.tranRel === true) {
          //   callingProg = 'Copy'
          // } else {
          //   callingProg = 'Draft'
          // }
          let callingProg = 'Draft'
          this.btnPrtSchForm.polNo = this.polNo
          this.btnPrtSchForm.endtCnt = this.endtCnt
          this.btnPrtSchForm.renCnt = this.renCnt
          this.btnPrtSchForm.callingProg = callingProg
          this.btnPrtSchForm.callingProgram = callingProg
          this.btnPrtSchForm.polTypeAppId = this.polTypeAppId
          if (this.schedForm === 'C' || this.schedForm === 'D') {
            this.btnPrtSchForm.uoiCustomised = true
          } else {
            this.btnPrtSchForm.uoiCustomised = false
          }
          let sendForm = {}
          sendForm = clone(this.btnPrtSchForm)
          // console.log(sendForm)
          await this.$http.post(apiURI, sendForm).then(() => {
            this.loading = false
          })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.loading = false
        this.printError = false
        this.errorMessage('Sent form to API failed. Please validate the field')
      }
    },
    getExportApiUri() {
      // console.log(this.reportMenu)
      if (this.polTypeAppId === 'CA' || this.polTypeAppId === 'MI' || this.polTypeAppId === 'FI' || this.polTypeAppId === 'MO') {
        return this.reportMenu.export
      } else if (this.polTypeAppId === 'HU') {
        return this.reportMenu.export_Hull
      }
      return ''
    }
  },
  props: {
    labelName: {
      type: String,
      default: 'No Label Name'
    },
    confirmFlag: {
      type: Boolean,
      default: false
    },
    polNo: {
      type: String,
      default: ''
    },
    renCnt: {
      type: Number,
      default: -1
    },
    endtCnt: {
      type: Number,
      default: -1
    },
    tranRel: {
      type: Boolean,
      default: false
    },
    schedForm: {
      type: String,
      default: ''
    }
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
